export default "__VITE_PUBLIC_ASSET__9597010d__"